import Facade from '@/Facade'
import { GameStatesEnum } from '@/states/GameStatesEnum'

//## Both the gesture handler in ReelsContainer and the offer popup in PopupManager have to answer
//## "may the player swipe right now?" the same way, otherwise the popup shows up for a gesture that
//## would do nothing. The two checks live here so they cannot drift apart.

/**
 * Swipe must not reach the game while it is loading, on the intro, or moving between base game and
 * a feature. The feature entry/exit states are listed on their own because the model flags read by
 * isFeatureRoundActive are cleared before the closing transition plays and set only after the
 * opening one, which left the swipe live for the whole length of the wave.
 */
const SWIPE_BLOCKED_STATES: ReadonlySet<string> = new Set<string>([
    GameStatesEnum.GET_INIT_RESPONSE_STATE,
    GameStatesEnum.BEFORE_LOADING_STATE,
    GameStatesEnum.LOADING_STATE,
    GameStatesEnum.INIT_STATE,
    GameStatesEnum.DISPLAY_SPLASH_SCREEN_STATE,
    GameStatesEnum.RESTORE_STATE,
    GameStatesEnum.FREE_SPINS_ACTIVATE_STATE,
    GameStatesEnum.FREE_SPINS_INTRO_STATE,
    GameStatesEnum.FREE_SPINS_RETRIGGER_STATE,
    GameStatesEnum.FREE_SPINS_SUMMARY_STATE,
    GameStatesEnum.HOLD_AND_WIN_ACTIVATE_STATE,
    GameStatesEnum.HOLD_AND_WIN_INTRO_STATE,
    GameStatesEnum.HOLD_AND_WIN_JACKPOT_POPUP_STATE,
    GameStatesEnum.HOLD_AND_WIN_SUMMARY_STATE,
])

export const isSwipeBlockedByGameState = (): boolean =>
    SWIPE_BLOCKED_STATES.has(String((Facade as any).currentState || ''))

/**
 * Free Game / Hold & Win spins are driven by the feature, so a swipe must neither spin nor
 * advertise the feature through its popup.
 */
export const isFeatureRoundActive = (): boolean => {
    const spinData: any = Facade.model?.spinData || {}
    const nextRoundType = String(spinData?.next_round_type || '').toLowerCase()
    const respinsLeft = Number(spinData?.respins_left ?? 0)
    const hasPendingRespins = (nextRoundType === 'respins' || nextRoundType === 'respin') && respinsLeft > 0

    return Boolean(
        Facade.model?.roundState?.isFreeSpins ||
            Facade.model?.spinState?.isHoldAndWinActive ||
            Facade.model?.isBonusGameNow ||
            hasPendingRespins
    )
}
